import { apiConfig } from "../config/api.config";
import { callAPI } from "./apiUtilities";

export const getPermissions = () => {
  return callAPI<any>(
    `${apiConfig.securityRootUrl}/permissions/user`,
    {
      method: "get"
    },
    true,
    false
  );
};
